<template>
  <div>
    <stats-card title="Saldo Timbres"
                type="gradient-orange"
                :sub-title="saldo.saldoTimbres | formatNumberInteger"
                icon="far fa-bell"
                class="mb-1">

      <template slot="footer">
        <span class="text-danger mr-2">{{ saldo.timbresAsignados | formatNumberInteger }}</span>
        <span class="text-nowrap">Timbres Asignados</span>
      </template>
    </stats-card>
  </div>
</template>
<script>
export default {
  name: 'facturacion-saldo-timbres',
  data: () => {
    return {
      saldo: {
        fechaExpiracion: null,
        saldoTimbres: 0,
        timbresAsignados: 0,
        timbresUtilizados: 0
      }
    }
  },
  beforeMount(){
    this.saldoTimbres()
  },
  methods: {
    saldoTimbres(){
      this.working = true

      this.$api
      .get('/facturacion/timbrado/saldo')
      .then(res => {
        if(res.data.status == 'success'){
          this.saldo = res.data.data
        }
      })
      .catch(e => this.error.push(e))
      .then(() => this.working = false)
    }
  },
  filters: {
    formatNumberDecimal: function(value){
      const options2 = { style: 'decimal', currency: 'USD', maximumFractionDigits: 2 };
      const numberFormat2 = new Intl.NumberFormat('en-US', options2);

      return numberFormat2.format(value);
    },
    formatNumberInteger: function(value){
      const options2 = { style: 'decimal', currency: 'USD', maximumFractionDigits: 0 };
      const numberFormat2 = new Intl.NumberFormat('en-US', options2);

      return numberFormat2.format(value);
    }
  }
}
</script>